import React from "react";

const DetailRow = ({ title, value, textJustify, children, last, valueColor }) => {
  return (
    <div className={`border-b-1 border-lg5 flex justify-between py-1 ${last}`}>
      <p className="font-figtree font-semibold text-dark-blue max-lg:text-[13px] max-md:text-xs pr-10">{title}</p>
      <p className={`font-poppins font-semibold max-lg:text-[13px] text-15 max-md:text-xs ${textJustify} ${valueColor}`}>
        {value} {children}
      </p>
    </div>
  );
};
export default DetailRow;
